import * as React from 'react';
import { Accordion, Card, Button, Form, Row, Col } from 'react-bootstrap';
import autobind from 'autobind-decorator';

interface IProps {
  title: string;
  description: string;
  onSaveInfoCallback: any;
}

interface IState {
}

export default class ConceptInfo extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
    }
  }

  @autobind
  onSave(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    let data = {
      title: form["title"].value,
      description: form["description"].value
    };
    this.props.onSaveInfoCallback(data);
  }

  public render() {
    return (

      <Accordion defaultActiveKey="-1" >
        <Card style={{ border: 'none' }}>
          <Accordion.Toggle as={Card.Header} eventKey="0" style={{ border: 'none', backgroundColor: 'white' }}>

            <h5>
              {this.props.title}
            </h5>
            <p style={{ color: 'grey' }}>
              {this.props.description}
            </p>

          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form onSubmit={this.onSave}>
                <Form.Group as={Row} controlId="title">
                  <Form.Label column sm={2}>
                    Title
                        </Form.Label>
                  <Col sm={10}>
                    <Form.Control required type="text" defaultValue={this.props.title} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="description">
                  <Form.Label column sm={2}>
                    Description
                        </Form.Label>
                  <Col sm={10}>
                    <Form.Control as="textarea" rows={4} defaultValue={this.props.description} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Col sm={{ span: 4, offset: 2 }}>
                    <Button variant="success" type="submit">Save</Button>
                  </Col>
                  <Col sm={{ span: 4, offset: 2 }}>
                    <Button variant="warning" type="reset">Revert</Button>
                  </Col>
                </Form.Group>
              </Form>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    )
  }
}
